import React from 'react';
import Skeleton from '../Skeleton';
import Typography from '../Typography';

export interface ChatThinkingProps {
    /** Names what is happening, when that is worth saying. Omitted, the bars speak alone. */
    label?: string;
    className?: string;
}

/** Uneven, so the block reads as prose arriving rather than as a loading graphic. */
const BAR_WIDTHS = ['92%', '76%', '58%'];

/**
 * Roughly the width a short reply would occupy. A percentage width only resolves against a
 * containing block whose OWN width is already known — inside `Chat.Message`'s `bubble`
 * variant, which hugs its content instead of filling the column, nothing sets that, so the
 * bars' percentages fell back to 0 and the bubble collapsed to its padding. This pixel floor
 * gives this component's own box a width regardless of variant, so the percentage bars inside
 * it have something to resolve against; `plain`/`card` already stretch past it and see no
 * change.
 */
const MIN_WIDTH_CLASS = 'min-w-[200px]';

/**
 * Shown while a reply is on its way but nothing has streamed in yet.
 *
 * Bars rather than a spinner: they occupy the shape the answer will take, so the transcript
 * does not jump when it lands, and there is no looping motion to look away from.
 */
const ChatThinking: React.FC<ChatThinkingProps> = ({ label, className = '' }) => (
    <div
        className={`flex flex-col gap-2 ${MIN_WIDTH_CLASS} ${className}`}
        role="status"
        aria-busy="true"
    >
        {label ? <Typography.SecondaryText size="xsmall">{label}</Typography.SecondaryText> : null}
        {BAR_WIDTHS.map((width) => (
            <Skeleton.Input key={width} width={width} height={12} />
        ))}
    </div>
);

export default ChatThinking;
export { ChatThinking };
